var map = {
	"./euro2024.webp": 1479,
	"./euro2024_title.svg": 1480,
	"./event-sport-bg.jpg": 1481,
	"./event-sport-bg.png": 1482,
	"./home-icon-active.webp": 1483,
	"./home-icon.webp": 1484,
	"./img_bg-uefa.png": 1485,
	"./live-icon-active.webp": 1486,
	"./master-bg.webp": 1487,
	"./me-icon-active.webp": 1488,
	"./product-overview-bg.webp": 1489,
	"./promos-icon-active.webp": 1490,
	"./sponsor-icon-active.webp": 1491,
	"./uefa-icon-active.webp": 1492,
	"./uefa-icon.webp": 1493,
	"./uefa-prediction.webp": 1494,
	"./wwr-img.webp": 1495
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;